module.exports = __webpack_public_path__ + "img/techtree.0.1.443fbec4.png";